export default "__VITE_ASSET__C8jGYxHf__"